import { ref } from 'vue';
import type { FieldSchema, RawField } from '@FormModule';
import type { GenericField } from '@Types';
import { useForm } from '@FormModule';

// NOTE :: The "share with the shelter" switch is for report managers only; the api ignores it for anyone else.
export default function (canShare: boolean) {
  const { getDetailsSchema } = useForm();

  const currentSchemaModels = ref<Set<GenericField>>(new Set());
  const fieldsSchema = ref<FieldSchema[]>([]);

  const RAW_FIELDS: RawField[] = [
    {
      label: 'filters.savedReports.name',
      name: 'name',
      required: true,
      type: 'text',
      value: '',
    },
    {
      label: 'filters.savedReports.isDefault',
      name: 'is_default',
      required: false,
      type: 'toggle',
      value: false,
    },
    {
      label: 'filters.savedReports.isShared',
      name: 'shareable',
      required: false,
      type: 'toggle',
      value: false,
    },
  ];

  // HELPERS
  function getField(name: string) {
    return fieldsSchema.value.find((field) => field.name === name);
  }

  function setForm() {
    const fields = RAW_FIELDS.filter(({ name }) => canShare || name !== 'shareable');

    fieldsSchema.value = getDetailsSchema(fields, {});
  }

  return {
    currentSchemaModels,
    fieldsSchema,
    getField,
    setForm,
  };
}
